"use client";
import { jsxs as b, jsx as e } from "react/jsx-runtime";
import { cva as x } from "class-variance-authority";
import { forwardRef as k, useState as T } from "react";
import { twMerge as V } from "tailwind-merge";
import { cn as l } from "../../../utils/utils.mjs";
import { Text as p } from "../Text/Text.mjs";
import { getAccessibleFocusStyles as j } from "../../../utils/styles.mjs";
const w = x(
  `
    px-6
    rounded-sm
    ${j()}
    cursor-pointer
    text-center
    border-transparent
    border-2
    flex
    items-center
    justify-center
    gap-x-2
    w-full
`,
  {
    variants: {
      variant: {
        primary: "bg-yellow-400 hover:bg-yellow-600 text-gray-900",
        secondary: "bg-gray-800 hover:bg-gray-900 text-white",
        "outlined-dark": "border-gray-800 text-gray-800 hover:bg-gray-900 hover:text-white",
        "outlined-light": "border-white text-white hover:text-gray-800 hover:bg-white hover:border-gray-800",
        text: "bg-transparent text-blue-700 hover:bg-gray-100 hover:text-blue-800",
        alternate: "bg-blue-700 hover:bg-blue-800 text-white"
      },
      size: {
        default: "py-1-5 min-h-[40px]",
        large: "py-3 min-h-[56px]"
      },
      disabled: {
        true: "bg-gray-200 text-gray-500 border-gray-200 hover:border-gray-200 focus:outline-none hover:bg-gray-200 hover:text-gray-500 cursor-not-allowed"
      },
      isLink: {
        true: "inline-flex items-center"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "default"
    }
  }
), a = x("w-4 h-4 fill-current hover:fill-current", {
  variants: {
    variant: {
      primary: "fill-current hover:fill-current",
      secondary: "fill-white hover:fill-gray-900",
      "outlined-dark": "fill-gray-800 hover:fill-white",
      "outlined-light": "fill-current hover:fill-current",
      text: "fill-current hover:fill-current",
      alternate: "fill-white hover:fill-gray-200"
    },
    disabled: {
      true: "fill-gray-500 hover:fill-gray-500"
    }
  }
}), L = k(
  ({
    children: s,
    variant: t,
    className: F = "",
    buttonClassName: u = "",
    size: i = "default",
    disabled: r = !1,
    href: c,
    iconPrefix: o,
    iconSuffix: h,
    ...g
  }, f) => {
    const d = i === "large" ? "base" : "sm", [B, y] = T(!1), m = (N) => {
      N.currentTarget.matches(":focus-visible") && y(!0);
    }, v = () => y(!1);
    let n;
    return c && !r ? n = /* @__PURE__ */ b(
      "a",
      {
        ...g,
        ref: f,
        className: l(w({ variant: t, size: i, disabled: r, isLink: !0 }), u),
        href: c,
        onFocus: m,
        onBlur: v,
        children: [
          o && /* @__PURE__ */ e("div", { className: l(a({ variant: t, disabled: r })), children: o }),
          /* @__PURE__ */ e(p, { asChild: !0, fontSize: d, children: /* @__PURE__ */ e("span", { children: s }) })
        ]
      }
    ) : n = /* @__PURE__ */ b(
      "button",
      {
        ...g,
        ref: f,
        className: l(w({ variant: t, size: i, disabled: r }), u),
        disabled: r,
        onFocus: m,
        onBlur: v,
        children: [
          o && /* @__PURE__ */ e("div", { className: l(a({ variant: t, disabled: r })), children: o }),
          /* @__PURE__ */ e(p, { asChild: !0, fontSize: d, children: /* @__PURE__ */ e("span", { children: s }) }),
          h && /* @__PURE__ */ e("div", { className: l(a({ variant: t, disabled: r })), children: h })
        ]
      }
    ), /* @__PURE__ */ e(
      "div",
      {
        className: V(
          "inline-block rounded-sm w-auto",
          B && "focus-within:outline-2 focus-within:outline-white focus-within:outline-offset-2",
          F
        ),
        children: n
      }
    );
  }
);
L.displayName = "Button";
export {
  L as Button
};
